<template>
  <div class="equity-activity-dialog-wrap">
    <div class="equity-activity-dialog" v-if="innerVisible">
        
      <div class="dialog-body"  id="equity-activity-body" v-if="pageConfig[type] && fullOrderActivity">
        <div class="close-btn" @click="close" v-if="pageConfig[type].showClose">
          <img src="../../../../assets/imgs/activity/three-order-activity/dialog-close-icon.png" />
        </div>

        <div class="dialog-content">

          <div class="three-order-activity" :class="[type]">
            <div class="activity-top">
              <div class="title">
                <img :src="pageConfig[type].titleImg" alt="">
              </div>
              <div class="sub-title">{{ pageConfig[type].subTitle }}</div>
            </div>

            <div class="activity-content">
              <!-- <div class="coupon-title" v-if="pageConfig[type].couponTitle">
                {{ pageConfig[type].couponTitle }}
              </div> -->
              
              <template v-if="pageConfig[type].type === 'coupon-discount'">
                <decorative-wrap
                  class="decorative-item"
                  :options="getOptions(index)"
                  v-for="(discount,index) in fullOrderActivity.coupon_list" 
                  :key="index">
                    <coupon-discount-item 
                      class="coupon-discount-item"  
                      :current="getCurrent(index)" 
                      :index="index"
                      :coupon="discount"
                    >
                    </coupon-discount-item>
                </decorative-wrap>
                
              </template>

              <template v-if="pageConfig[type].type === 'coupon-common'">
                  <decorative-wrap :options="{ topShine: true }">
                    <decorative-wrap 
                      class="coupon-common-item"
                      v-for="(coupon, index) in fullOrderActivity.completed_coupon_list" 
                      :key="index"
                      :options="{ couponBlur: true }">
                        <coupon-common-item 
                          :coupon="coupon">
                        </coupon-common-item>
                    </decorative-wrap>
                  </decorative-wrap>
              </template>

              <template v-if="pageConfig[type].type === 'full-amount'">
                <decorative-wrap :options="{ topShine: true }">
                  <decorative-wrap :options="{ blur: true }">
                    <activity-receive-discount 
                      class="activity-receive-discount-box" 
                      :peer-activity-record-id="fullOrderActivity.next_activity_record_id"
                      :options="{hideTips: true}">
                    </activity-receive-discount>
                  </decorative-wrap>
                </decorative-wrap>
              </template>

            </div>
            <div class="activity-footer" v-if="pageConfig[type].footer">
              <div class="btn" @click="close">
                {{ pageConfig[type].footer.closeBtnText }}
              </div>
            </div>

            </div>

        </div>
      </div>

    </div>
  </div>
</template>


<script>
import couponDiscountItem from '@/components/activity/coupon-item/coupon-discount-item';
import couponCommonItem from '@/components/activity/coupon-item/coupon-common-item/coupon-common-item';
import activityReceiveDiscount from '@/components/activity/activity-receive-discount';
import decorativeWrap from '@/components/activity/decorative-wrap';

export default {
  components: {
    couponDiscountItem,
    couponCommonItem,
    activityReceiveDiscount,
    decorativeWrap,
  },
  props: {
    // 是否打开
    visible: {
      type: Boolean,
      default: false,
    },
    fullOrderActivity: Object,
    componentInfo: {
      type: Object,
      default: () => ({}),
    },
    // 订单支付时候需要等待关闭再进行下一步
    resolve: Function,
  },
  data() {
    return {
      currentProgress: 0,
      pageConfig: {
        default: {
          // title: '新用户专享',
          titleImg: require('../../../../assets/imgs/activity/three-order-activity/activity-dialog-title-default.png'),
          subTitle: '三单挑战 最高优惠400元',
          type: 'coupon-discount',
        },
        first: {
          // title: '您已经完成了第一单',
          titleImg: require('../../../../assets/imgs/activity/three-order-activity/activity-dialog-title-first.png'),
          subTitle: '目标已经完成33%',
          type: 'coupon-discount',
        },
        second: {
          // title: '您已经完成了第二单',
          titleImg: require('../../../../assets/imgs/activity/three-order-activity/activity-dialog-title-second.png'),
          subTitle: '目标已经完成66%',
          type: 'coupon-discount',
        },
        finish: {
          // title: '您已经完成了三单挑战',
          titleImg: require('../../../../assets/imgs/activity/three-order-activity/activity-dialog-title-finish.png'),
          subTitle: '以下权益已解锁',
          couponTitle: '权益一: 优惠券包已到账',
          type: 'coupon-common',
          showClose: true,
          footer: {
            closeBtnText: '立即下单',
          },
        },
        'full-amount': {
          // title: '您已经完成了三单挑战',
          titleImg: require('../../../../assets/imgs/activity/three-order-activity/activity-dialog-title-finish.png'),
          subTitle: '以下权益已解锁',
          couponTitle: '权益二：满额优惠活动已开启',
          type: 'full-amount',
          showClose: true,
          footer: {
            closeBtnText: '好的',
          },
        },
      },
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close', value);
          // 订单支付成功需要进行告知然后再进行下一步处理
          if (this.resolve && typeof this.resolve === 'function') {
            this.resolve();
          }
        }
        return value;
      },
    },
    // 是否有满额活动
    hasFullAmount() {
      if (!this.fullOrderActivity) return; 
      // 判断是否完成三单挑战，并且是否有下一个活动
      const hasFullAmount = this.fullOrderActivity.is_complete && this.fullOrderActivity.next_activity_record_id;
      return hasFullAmount;
    },
    type() {
      return ['default', 'first', 'second', 'finish', 'full-amount'][this.currentProgress];
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.fullOrderActivity) return; 
      // 判断是否完成，如果是则设置当前样式为finish，如果有下一个权益，则按钮显示下一步
      if (this.hasFullAmount) {
        this.pageConfig.finish.footer.closeBtnText = '下一步';
      }
      this.currentProgress = this.fullOrderActivity.last_threshold_num;

      // // 设置动画
      if (!this.fullOrderActivity.is_complete) {
        this.closeAnimation();
      }
      
    },
    getOptions(index) {
      let shine = false;
      let blur = false;
      if (this.type === 'default') {
        blur = true;
      } else if (this.type === 'first') {
        // 第一单完成,第二个需要发光
        shine = index === 1;
        blur = index === 1;
      } else if (this.type === 'second') {
        // 第二单完成,第三个需要发光
        shine = index === 2;
        blur = index === 2;
      }
      return {
        blur,
        shine,
      };
    },
    getCurrent(index) {
      if (this.type === 'default') {
        return index === 0; // 第一个显示当前样式
      } else if (this.type === 'first') {
        return index === 1; // 第一个显示当前样式
      } else if (this.type === 'second') {
        return index === 2; // 第一个显示当前样式
      }
      
    },
    // 关闭
    close() {
      // 判断是否有下一个权益
      if (this.hasFullAmount && this.currentProgress !== 4) {
        this.currentProgress = 4;
        return;
      }

      this.innerVisible = false;
    },
    // 设置首页展示的位置
    setIndexThreeOrderActivityPosition() {
      this.$nextTick(() => {
        // 关闭
        const dialog = this.$el.querySelector('#equity-activity-body');
        if (!dialog) return;
        const { width, height, top, left } = this.componentInfo;
        if (width && height) {
          dialog.style.top = `${top + height / 2}px`;
          dialog.style.left = `${left + width / 3}px`;
        }
      });
    },

    closeAnimation() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.setIndexThreeOrderActivityPosition();
          // 关闭
          const dialog = this.$el.querySelector('#equity-activity-body');
          if (!dialog) return;
          dialog.classList.add('close-animation');
          setTimeout(() => {
            this.innerVisible = false;
            resolve();
          }, 800);
        }, 4000); // 打开时候有一秒动画,所以该效果为等待3秒关闭
      });
    },

  },
};
</script>

<style lang="less" scoped>
@sub-title-color: #FFEDC9;
@title-color: #FFFFFF;
@title-top-bg: #FFCB67;
@title-bg: linear-gradient(90deg, #FFD78E 0%, #FFFAEE 100%);
@discount-title-color: #E34236;
@discount-color: #FEF7D8;

.equity-activity-dialog-wrap{

  .equity-activity-dialog {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, .6);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 2002;
  }

  .dialog-body {
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: all 1s;
    animation: openAnimation 1s;
    @keyframes openAnimation {
      0% {
        left: 50%;
        top: 50%; 
        transform: translate(-50%, -50%) scale(0);
        opacity: 0; 
      }
      100% {
        left: 50%;
        top: 50%; 
        transform: translate(-50%, -50%) scale(1);
        opacity: 1; 
      }
    }
    .dialog-content {
      .three-order-activity{
        display: flex;
        flex-direction: column;
        align-items: center;
        background: url(../../../../assets/imgs/activity/three-order-activity/blur-title-bg.png) no-repeat center center;
        background-size: 100% 100%;
        // 标题样式
        .activity-top {
          position: relative;
          margin-top: 86px;
          z-index: 1;
          .title {
            text-align: center;
            >img {
              height: 56px;
            }
            &::before {
              content: '';
              display: inline-block;
              width: 446px;
              height: 128px;
              background: @title-top-bg;
              position: absolute;
              background: url(../../../../assets/imgs/activity/three-order-activity/title-blur-point.png) no-repeat center center;
              background-size: 100% 100%;
              top: -50%;
              left: 50%;
              transform: translate(-50%, 0);
            }
          }
          .sub-title {
            margin-top: 8px;
            font-size: 28px;
            line-height: 40px;
            color: @sub-title-color;
            text-align: center;
          }
        }

        .activity-content {
          margin-top: 48px;
          display: flex;
          justify-content: space-between;

          .decorative-item {
            margin-left: 40px;
            &:first-child {
              margin-left: 0;
            }
          }
          .coupon-title {
            font-size: 20px;
            color: #FFEDC1;
            line-height: 28px;
            line-height: 33px;
            margin-bottom: 24px;
            position: relative;
            z-index: 1;
          }
        } 

        .activity-footer {
          display: flex;
          flex-direction: column;
          margin-top: 40px;
          position: relative;
          .btn {
            width: 140px;
            height: 42px;
            line-height: 42px;
            background: linear-gradient(#FE373B 0%, #FF6F54 100%);
            box-shadow: inset 2px -6px 3px 0px rgba(255,228,147,0.25);
            border-radius: 21px;
            border: 2px solid;
            color: #fff;
            font-size: 18px;
            text-align: center;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
  
      .three-order-activity.default {
        width: 614px;
        height: 614px;
      }

      // 完成第一单样式
      .three-order-activity.first {
        background: transparent;
        .activity-content {
          display: flex;
          align-items: center;
          margin-top: 72px;
          .decorative-item {
            position: relative;
            zoom: 0.8;
            margin-left: -6px;
            &:first-child {
              margin-left: 0;
            }
            &:not(:nth-child(2)) {
              &::before {
                content: '';
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                background-color: #000;
                opacity: 0.3;
                filter: blur(2px);
                z-index: 3;
                border-radius: 16px;
              }
            }
            &:nth-child(2) {
              zoom: 1.2;
              z-index: 4;
            }
          }
        }
      }


      // 完成第二单样式
      .three-order-activity.second {
        background: transparent;
        .activity-content {
          display: flex;
          align-items: center;
          margin-top: 72px;
          .decorative-item{
            margin-left: 20px;
            zoom: 0.8;
            &:first-child {
              margin-left: 0;
            }
            &:not(:nth-child(3)) {
              &::before {
                content: '';
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                background-color: #000;
                opacity: 0.3;
                filter: blur(2px);
                z-index: 3;
                border-radius: 16px;
              }
            }
            &:nth-child(3) {
              margin-left: 16px;
              zoom: 1.2;
              z-index: 4;
            }
          }
        }
      }


      // 完成三单样式
      .three-order-activity.finish {
        background: transparent;
        position: relative;
        .activity-content {
          margin-top: 60px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .coupon-common-item {
            margin-top: 16px;
            &:first-child {
              margin-top: 0;
            }
          }
        }
      }


      // 满额活动
      .three-order-activity.full-amount {
        background: transparent;
        .activity-top {
          margin-top: 56px;
        }
        .activity-content {
          margin-top: 60px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .activity-receive-discount-box {
          width: 672px;
          background: #FFFFFF;
          padding: 16px;
          border-radius: 2px;
        }
      }

    }
    .close-btn {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      cursor: pointer;
      z-index: 1;
      img {
        width: 32px;
        height: 32px;
      }
    }
  }


  .dialog-body.open-animation {
    left: 50%!important;
    top: 50%!important; 
    transform: translate(-50%, -50%) scale(1);
    opacity: 1; 
  }
  .dialog-body.close-animation {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0; 
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/index/components/equity-activity-dialog/equity-activity-dialog.vue